// removed by extract-text-webpack-plugin
module.exports = {"root":"_1JDIF","title":"_1dhH4","postList":"_2wT26","order":"_w6v1h","info":"_1sAyh","description":"_2MKLX","time":"_1ER_e","dot":"_2H_5-","postLink":"_2MfK4","thumbnail":"_5zaBQ","postListItem":"_2vrPA","headingPostTitle":"_2zZDo"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Home/components/TrendBlock/TrendBlock.scss
// module id = 1116
// module chunks = 2